/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Chargers properties that can be used for sorting. Default value is 'assetSourceId'.
 *
 */
export var ChargerPropertiesForSorting;
(function (ChargerPropertiesForSorting) {
    ChargerPropertiesForSorting["ASSET_SOURCE_ID"] = "assetSourceId";
    ChargerPropertiesForSorting["LAST_KNOWN_CHARGER_STATUS"] = "lastKnownChargerStatus";
})(ChargerPropertiesForSorting || (ChargerPropertiesForSorting = {}));
